import { AccessorialCode } from '@rygen/rygen-ui/model/AccessorialCode';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'accessorial-code';

export class AccessorialCodeController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async findAll(): Promise<AccessorialCode[]> {
    const response = await this.http.get<AccessorialCode[]>('');
    return response.data.map((val) => new AccessorialCode(val));
  }

  async findAllRequestable(): Promise<AccessorialCode[]> {
    const response = await this.http.get<AccessorialCode[]>('requestable');
    return response.data.map((val) => new AccessorialCode(val));
  }
}
